import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactForm = () => {
  const formRef = useRef();

  const isValidCanadianPhone = (phone) => {
    const regex =
      /^(\+1)?\s?\(?[2-9][0-9]{2}\)?[\s.-]?[0-9]{3}[\s.-]?[0-9]{4}$/;
    return regex.test(phone);
  };

  const sendEmail = (e) => {
    e.preventDefault();

    const form = formRef.current;
    const phone = form.user_phone.value.trim();
    const renovationTimeline = form.renovation_timeline.value;
    const contactMethod = form.contact_method.value;

    if (!isValidCanadianPhone(phone)) {
      toast.error("Please enter a valid Canadian phone number.");
      return;
    }

    if (!renovationTimeline || !contactMethod) {
      toast.error("Please select all required options.");
      return;
    }

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID2,
        form,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          toast.success(
            "Success! We’ve received your message and will respond soon."
          );
          form.reset();
        },
        (error) => {
          toast.error("An error occurred, please try again.", error);
        }
      );
  };

  return (
    <div
      style={{
        backgroundColor: "#d5a84d",
        padding: "50px 1rem",
        fontFamily: "Barlow Condensed",
      }}
    >
      <ToastContainer position="top-center" autoClose={4000} />
      <div className="container px-2 px-md-4 px-lg-5">
        <h2
          className="text-center text-white fw-bold mb-3"
          style={{ fontSize: "2.5rem" }}
          data-sal="slide-up"
          data-sal-duration="800"
        >
          LET’S START SOMETHING NEW — SAY HELLO!
        </h2>

        <p
          className="text-center text-white mb-5"
          style={{ fontSize: "1.2rem", maxWidth: "800px", margin: "0 auto" }}
          data-sal="fade"
          data-sal-duration="700"
          data-sal-delay="200"
        >
          Please contact us to book an estimate and to inquire about the needs
          for your specific
          <br className="d-none d-md-block" />
          bathroom remodelling project!
        </p>

        <form
          ref={formRef}
          onSubmit={sendEmail}
          className="bg-transparent"
          data-sal="zoom-in"
          data-sal-duration="1000"
          data-sal-delay="300"
        >
          <div className="row">
            <div
              className="col-md-6 mb-3"
              data-sal="slide-right"
              data-sal-duration="600"
            >
              <input
                type="text"
                name="user_name"
                className="form-control p-3"
                placeholder="Name:"
                required
              />
            </div>
            <div
              className="col-md-6 mb-3"
              data-sal="slide-left"
              data-sal-duration="600"
            >
              <input
                type="text"
                name="user_phone"
                className="form-control p-3"
                placeholder="Phone number:"
                required
              />
            </div>
          </div>

          <div className="mb-3" data-sal="fade" data-sal-duration="600">
            <input
              type="email"
              name="user_email"
              className="form-control p-3"
              placeholder="Email:"
              required
            />
          </div>

          <div
            className="mb-3"
            data-sal="fade"
            data-sal-duration="600"
            data-sal-delay="100"
          >
            <textarea
              name="message"
              className="form-control p-3"
              rows="4"
              placeholder="Message:"
              required
            ></textarea>
          </div>

          <div
            className="mb-3"
            data-sal="fade"
            data-sal-duration="600"
            data-sal-delay="200"
          >
            <label className="form-label text-white fw-bold">
              How soon are you looking to renovate your bathroom?
            </label>
            <select
              name="renovation_timeline"
              className="form-select p-3"
              required
            >
              <option value="">Please Select</option>
              <option value="Immediately">Immediately</option>
              <option value="Within 1-3 months">Within 1-3 months</option>
              <option value="In 6 months or later">In 6 months or later</option>
            </select>
          </div>

          <div
            className="mb-4"
            data-sal="fade"
            data-sal-duration="600"
            data-sal-delay="300"
          >
            <label className="form-label text-white fw-bold">
              How do you prefer to be contacted?
            </label>
            <select name="contact_method" className="form-select p-3" required>
              <option value="">Please Select</option>
              <option value="Email">Email</option>
              <option value="Phone">Phone</option>
              <option value="Text">Text</option>
            </select>
          </div>

          <div
            className="text-center"
            data-sal="zoom-in"
            data-sal-duration="700"
            data-sal-delay="400"
          >
            <button
              type="submit"
              className="btn btn-dark px-5 py-3 fw-bold rounded-pill custom-btn1"
              style={{ fontSize: "1rem" }}
            >
              I'M INTERESTED!
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
